import { PatientActions } from 'src/redux/actions/constant';

const {
  GET_SINGLE_PATIENT_SUCCESS,
  GET_SINGLE_PATIENT_REQUEST,
  GET_SINGLE_PATIENT_FAILURE,
  GET_SINGLE_PATIENT_LOADING,
} = PatientActions;

const intialPatientState: object = {
  patient: null,
  isError: false,
  errorMessage: '',
  loading: false,
};
export const getSinglePatientReducer = (state = intialPatientState, action: any) => {
  switch (action.type) {
    case GET_SINGLE_PATIENT_SUCCESS: {
      return {
        ...state,
        isError: false,
        loading: false,
        patient: action.payload?.data,
      };
    }

    case GET_SINGLE_PATIENT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        patient: null,
        loading: false,
      };

    case GET_SINGLE_PATIENT_LOADING:
    case GET_SINGLE_PATIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
